import React from 'react';
import PropType from 'prop-types';
import { Transition } from 'react-spring/renderprops';

import Icon from '../../../00_atoms/icon/Icon';

/*
 * Art Module
 * ---------------------
 * This small module shows the artwork and flipcard for the currently active media
 */

class AudioPlayerComponentActiveMediaArt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flipped: false,
    };

    const dataActiveShow = this.props.dataActiveShow;
    const backOfCardImage =
      typeof dataActiveShow.alt_image !== 'undefined' &&
      dataActiveShow.alt_image !== ''
        ? dataActiveShow.alt_image
        : false;

    const backOfCardMessage =
      typeof dataActiveShow.alt_text !== 'undefined' &&
      dataActiveShow.alt_text !== ''
        ? dataActiveShow.alt_text
        : false;

    if (backOfCardImage || backOfCardMessage) {
      this.setUpInterval();
    }

    this.flipCard = this.flipCard.bind(this);
    this.setUpInterval = this.setUpInterval.bind(this);
    this.destroyInterval = this.destroyInterval.bind(this);
    this.actionInterval = this.actionInterval.bind(this);
  }

  componentDidUpdate() {
    if (
      (this.props.audioState === 'stream off' ||
        this.props.audioState === 'podcast off') &&
      this.state.flipped
    ) {
      this.setState({
        flipped: false,
      });
    }
  }

  componentWillUnmount() {
    this.destroyInterval();
  }

  setUpInterval() {
    console.log('SETTING UP INTERVAL');
    const object = this;
    if (
      window.audioCardFlipInterval !== false &&
      typeof window.audioCardFlipInterval !== 'undefined'
    )
      return;
    window.audioCardFlipInterval = setInterval(() => {
      object.actionInterval(object);
    }, 7500);
  }

  destroyInterval() {
    console.log('DESTROYING INTERVAL');
    console.log(this);
    console.log(this.state.interval);
    clearInterval(window.audioCardFlipInterval);
  }

  actionInterval(object) {
    let isHidden = false;
    if (typeof document.hidden !== 'undefined') {
      isHidden = document.hidden;
    } else if (typeof document.msHidden !== 'undefined') {
      isHidden = document.msHidden;
    } else if (typeof document.webkitHidden !== 'undefined') {
      isHidden = document.webkitHidden;
    }

    if (object.props.audioState === 'stream on' && !isHidden) {
      object.setState({
        flipped: !object.state.flipped,
      });
    }
  }

  flipCard(event) {
    console.log('FLIP CARD TRIGGERED');
    const targetClassList = event.target.classList;
    if (
      event.target.type === 'use' ||
      targetClassList.contains('pa-icon__symbol') ||
      targetClassList.contains('pa-icon') ||
      targetClassList.contains(
        'po-audio-player__component-active-media__art__play-button'
      )
    ) {
      return;
    }
    this.destroyInterval();

    const audioState = this.props.audioState;

    if (audioState === 'stream off' || audioState === 'podcast off') {
      this.setState({
        flipped: false,
      });
      return;
    }

    this.setState({
      flipped: !this.state.flipped,
    });

    window.ArnAnalytics.customEvent({
      category: 'Audio Player',
      action: 'Flip card activated',
    });
  }

  render() {
    const dataActiveShow = this.props.dataActiveShow;
    const dataPodcast = this.props.dataPodcast;
    const audioState = this.props.audioState;
    const isExpanded = this.props.isExpanded;

    const flipped = this.state.flipped;

    let artUrl = dataActiveShow.player_image_url;

    let artType = 'talent';
    const hideOnDefaultImage = dataActiveShow.is_default ? 'transparent' : '';
    if (audioState === 'podcast on' || audioState === 'podcast off') {
      artUrl = dataPodcast.podcast_art;
      artType = 'podcast';
    }

    const springConfig = {
      mass: 5,
      tension: 500,
      friction: 80,
    };

    const backOfCardImage =
      typeof dataActiveShow.alt_image !== 'undefined' &&
      dataActiveShow.alt_image !== ''
        ? dataActiveShow.alt_image
        : false;

    const backOfCardMessage =
      typeof dataActiveShow.alt_text !== 'undefined' &&
      dataActiveShow.alt_text !== ''
        ? dataActiveShow.alt_text
        : false;

    let backOfCardLink =
      typeof dataActiveShow.alt_link !== 'undefined' &&
      dataActiveShow.alt_link !== ''
        ? dataActiveShow.alt_link
        : false;
    if (backOfCardLink && backOfCardLink.substring(0, 4) !== 'http') {
      backOfCardLink = `http://${backOfCardLink}`;
    }

    let flipScale = 1;
    const stylesEnter = {
      opacity: 1,
      transform: `perspective(600px) rotateX(0deg) scaleX(${flipScale})`,
    };

    flipScale = flipped ? 1.5 : 0.5;
    const stylesLeave = {
      opacity: 0,
      transform: `perspective(600px) rotateX(-180deg) scaleX(${flipScale})`,
    };

    flipScale = flipped ? 0.5 : 1.5;
    const stylesStart = {
      opacity: 0,
      transform: `perspective(600px) rotateX(180deg) scaleX(${flipScale})`,
    };

    let noArtClass = ``;
    if (!artUrl) {
      noArtClass = 'po-audio-player__component-active-media__art__empty';
    }

    const backOfCardStyles = {};
    if (backOfCardImage && backOfCardMessage) {
      backOfCardStyles.fontSize = '16px';
    } else if (backOfCardMessage.length < 64) {
      backOfCardStyles.fontSize = '28px';
    } else if (
      backOfCardMessage.length >= 64 &&
      backOfCardMessage.length <= 128
    ) {
      backOfCardStyles.fontSize = '20px';
    } else {
      backOfCardStyles.fontSize = '16px';
    }

    const views = [
      style => (
        <div
          style={style}
          className={`po-audio-player__component-active-media__art__placeholder ${noArtClass}`}
        >
          <img
            className={`po-audio-player__component-active-media__art__talent`}
            src={artUrl}
            alt={''}
          />
          {audioState === 'podcast off' || audioState === 'stream off' ? (
            <div
              onClick={this.props.handlePlayPause}
              className={`po-audio-player__component-active-media__art__play-button`}
            >
              <Icon
                iconName={`Play`}
                iconTitle={`Play`}
                xLink={`/wp-content/themes/arn/assets/icons/sprite.svg`}
              />
            </div>
          ) : null}
        </div>
      ),
      style => (
        <div
          style={style}
          className={`po-audio-player__component-active-media__art__back-of-card`}
        >
          <div>
            {backOfCardImage && !backOfCardMessage && !backOfCardLink ? (
              <div className={`img-container`}>
                <img src={backOfCardImage} alt={`Learn more`} />
              </div>
            ) : null}
            {backOfCardImage && !backOfCardMessage && backOfCardLink ? (
              <a href={backOfCardLink} rel={`nofollow`} target={`_blank`}>
                <div className={`img-container`}>
                  <img src={backOfCardImage} alt={`Learn more`} />
                </div>
              </a>
            ) : null}
            {backOfCardImage && backOfCardMessage ? (
              <div className={`img-container`}>
                <img src={backOfCardImage} alt={`Learn more`} />
              </div>
            ) : null}
            {backOfCardLink && backOfCardMessage ? (
              <a href={backOfCardLink} rel={`nofollow`} target={`_blank'`}>
                <p style={backOfCardStyles}>{backOfCardMessage}</p>
              </a>
            ) : null}
            {backOfCardMessage && !backOfCardLink ? (
              <p style={backOfCardStyles}>{backOfCardMessage}</p>
            ) : null}
            {!backOfCardImage && !backOfCardMessage && !backOfCardLink ? (
              <p style={{ fontSize: '28px' }}>
                Listen to more live radio on iHeartRadio
              </p>
            ) : null}
          </div>
        </div>
      ),
    ];

    const viewNum = flipped ? 1 : 0;

    return (
      <div className={`po-audio-player__component-active-media__art`}>
        {isExpanded ? (
          <div
            className={`po-audio-player__component-active-media__art__square`}
            onClick={event => {
              this.flipCard(event);
            }}
          >
            <Transition
              config={springConfig}
              from={stylesStart}
              enter={stylesEnter}
              leave={stylesLeave}
              items={viewNum}
            >
              {index => views[index]}
            </Transition>
          </div>
        ) : (
          <div
            className={`po-audio-player__component-active-media__art__small`}
          >
            <img
              className={`po-audio-player__component-active-media__art__${artType} po-audio-player__component-active-media__art__${hideOnDefaultImage}`}
              src={artUrl}
              alt={''}
            />
          </div>
        )}
      </div>
    );
  }
}

AudioPlayerComponentActiveMediaArt.propTypes = {
  dataActiveShow: PropType.object.isRequired,
  audioState: PropType.string.isRequired,
  dataPodcast: PropType.object.isRequired,
  isExpanded: PropType.bool.isRequired,
  handlePlayPause: PropType.func.isRequired,
};

export default AudioPlayerComponentActiveMediaArt;
